module.exports = __webpack_public_path__ + "static/media/Koch Engineered Solutions.46d0b64b.svg";